<report-tab-content [header]="'Admin_Reports_Tab_Videos_Header' | translate : {'0': (AnalyticsService.dateFilter$ | async)?.label }" [showDateFilter]="true">
	<video-report-kpis [data]="(kpis$ | async)">
	</video-report-kpis>
	<div layout="row">
		<vb-ui-report-cell [ngClass]="styles.mediumChartWrapper" [header]="'Title_Views' | translate" [noHeaderBottomBorder]="true" [size]="'large'">
			<vb-ui-line-chart class="height-full" [dateField]="'key'" [data]="viewsByDay$ | async" [integerValueAxis]="true" [valueField]="'value'">
			</vb-ui-line-chart>
		</vb-ui-report-cell>
	</div>
	<vb-ui-tab-panel flex="fill" [verticalFill]="false" [tabPanelInfoTemplate]="tabInfoTemplate">
		<vb-ui-tab #topCountTab [heading]="'Title_TopCountVideos' | translate : {'0': topVideosCount}">
			<videos-top-hits-grid *ngIf="topCountTab.isActive" [accountId]="accountId" [header]="'Title_TopCountVideos' | translate : {'0': topVideosCount}" [topHitsCount]="topVideosCount">
			</videos-top-hits-grid>
		</vb-ui-tab>
		<vb-ui-tab #viewsTab [heading]="'Title_Views' | translate">
			<views-grid *ngIf="viewsTab.isActive" [accountId]="accountId" [header]="'Title_Views' | translate">
			</views-grid>
		</vb-ui-tab>
	</vb-ui-tab-panel>
	<ng-template #tabInfoTemplate>
		<div layout="row" flex="fill">
			<div [ngClass]="styles.downloadWrapper">
				<span [ngClass]="styles.dateRangeText">
					{{ (AnalyticsService.dateFilter$ | async)?.label }}
				</span>
				<vb-dropdown-menu class="box-inline-block" [alignMenu]="'right'" [buttonTitle]="'Reports_Csv' | translate" [cssClass]="styles.menuDropDownContent" [icon]="'download_alt'">
					<ul [ngClass]="styles.menuDropdown">
						<li [ngClass]="styles.menuItem">
							<a [ngClass]="styles.menuItemLink" [href]="topHitsDownloadUrl" download>
								<span class="vb-icon vb-icon-csv"></span>
								{{ 'Title_TopCountVideos' | translate : {'0': 50} }}
							</a>
						</li>
						<li [ngClass]="styles.menuItem">
							<a [ngClass]="styles.menuItemLink" [href]="viewsDownloadUrl" download>
								<span class="vb-icon vb-icon-csv"></span>
								{{ 'Title_Views' | translate }}
							</a>
						</li>
					</ul>
				</vb-dropdown-menu>
			</div>
		</div>
	</ng-template>
</report-tab-content>

